import React from 'react'
import PropTypes from 'prop-types'

import noData from '../assets/images/data-not-found.svg'
import noDataLight from '../assets/images/data-not-found-light.svg'

export const NoDataCard = ({ isLayoutDark, schemaNotConfigured }) => {
  if (schemaNotConfigured === true) {
    if (isLayoutDark) {
      return (
        <div className="trtui-card trtui-card-height-100">
          <div className="trtui-card-body">
            <div className="trtui-text-center">
              <img src={noDataLight} alt="noData" className="trtui-w-25 trtui-mb-3 trtui-mt-4" />
              <br />
              Module Not Configured properly!
            </div>
          </div>
        </div>
      )
    } else {
      return (
        <div className="trtui-card trtui-card-height-100">
          <div className="trtui-card-body">
            <div className="trtui-text-center">
              <img src={noData} alt="noData" className="trtui-w-25 trtui-mb-3 trtui-mt-4" />
              <br />
              Module Not Configured properly!
            </div>
          </div>
        </div>
      )
    }
  }
  if (isLayoutDark) {
    return (
      <div className="trtui-card trtui-card-height-100">
        <div className="trtui-card-body">
          <div className="trtui-text-center">
            <img src={noDataLight} alt="noData" className="trtui-w-25 trtui-mb-3 trtui-mt-4" />
            <br />
            No data to show
          </div>
        </div>
      </div>
    )
  } else {
    return (
      <div className="trtui-card trtui-card-height-100">
        <div className="trtui-card-body">
          <div className="trtui-text-center">
            <img src={noData} alt="noData" className="trtui-w-25 trtui-mb-3 trtui-mt-4" />
            <br />
            No data to show
          </div>
        </div>
      </div>
    )
  }
}

NoDataCard.propTypes = {
  isLayoutDark: PropTypes.bool.isRequired,
  schemaNotConfigured: PropTypes.bool,
}
